import { ROLES } from '@/models/Rolle';
import RolleIndexView from '@/views/auth/system/rolle/IndexView.vue';
import RolleEditView from '@/views/auth/system/rolle/_id.vue';
import BenutzerIndexView from '@/views/auth/system/benutzer/IndexView.vue';
import BenutzerEditView from '@/views/auth/system/benutzer/_id.vue';
import ProfileView from '@/views/auth/system/ProfileView.vue';
import TestView from '@/views/auth/system/TestView.vue';

export default [
    {
        path: '/system/rolle',
        meta: {
            requiresAuth: true,
            roles: [ROLES.systemeinstellungen],
        },
        children: [
            {
                path: '',
                name: 'system_rolle',
                component: RolleIndexView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.systemeinstellungen],
                },
            },
            {
                name: 'system_rolle_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: RolleEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.systemeinstellungen],
                },
            },
        ],
    },
    {
        path: '/system/benutzer',
        meta: {
            requiresAuth: true,
            roles: [ROLES.systemeinstellungen],
        },
        children: [
            {
                path: '',
                name: 'system_benutzer',
                component: BenutzerIndexView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.systemeinstellungen],
                },
            },
            {
                name: 'system_benutzer_edit',
                path: ':id(\\d+|new)',
                props: true,
                component: BenutzerEditView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.systemeinstellungen],
                },
            },
        ],
    },
    {
        path: '/system',
        name: 'test_view',
        component: TestView,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/system/profile',
        name: 'profile',
        component: ProfileView,
        meta: {
            requiresAuth: true,
        },
    },
];
